export default {
  accrualCalculatorHistory: [],
  activeConsultants: [],
  activeUser: {},
  availableHours: [],
  availableHoursHistory: [],
  availableHoursNotes: [],
  consultants: [],
  blackoutPeriod: false,
  calculableAccrualQuarters: [],
  eligableHours: [],
  frequentlyAskedQuestions: [],
  hourUtilizationRequests: [],
  hoursTransationTypes: [],
  profile: {
    name: "user",
    settings: { useDarkTheme: true },
    ghost: null,
    ghostEmployeeType: null,
    showOptions: false,
    ghostShowOptions: false,
    ghostShowVouchers: false,
    ghostIsManager: false,
    ghostPtoEmployeeId: null,
    employeeId: null,
    dataEmployeeId: null,
    ptoEmployeeId: null
  },
  today: {},
  utilization: {},
  utilizationRequestStatuses: [],
  ptoDetails: {
    yearRolloverBalance: {
      year: 0,
      rolloverBalance: 0
    },
    monthDetails: [],
    totals: {
      earnedHours: 0,
      usedHours: 0,
      netEarnedHours: 0,
      availableHours: 0
    }
  },
  presClubDetails: {
    revDetails: {},
    utilDetails: {}
  },
  presClubAdminDetails: {
    revAdminDetails: {},
    utilAdminDetails: {}
  }
};
